import { render, staticRenderFns } from "./scientificeAndResearch.vue?vue&type=template&id=38318d02&scoped=true"
import script from "./scientificeAndResearch.vue?vue&type=script&lang=js"
export * from "./scientificeAndResearch.vue?vue&type=script&lang=js"
import style0 from "./scientificeAndResearch.vue?vue&type=style&index=0&id=38318d02&prod&scoped=scoped&lang=scss"
import style1 from "./scientificeAndResearch.vue?vue&type=style&index=1&id=38318d02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38318d02",
  null
  
)

export default component.exports